require("./calcalist_site_articleImageSlider.less")
import Slider from "react-slick"
import { imageListGalleryCalcalist } from "./articleImageSliderEditor";
import { ArticleImagesFullScreenGallery } from "../../../article/componentas/articleImagesFullScreenGallery/articleImagesFullScreenGallery";


interface ArticleImageSliderProps {
    imageList: imageListGalleryCalcalist[]
    infinite?: boolean
    width?: string
    height?: string
    style?: any
    imageSliderWidth?: string
    isRtl?: boolean
    shouldDisplayCurrentImageIndex?: boolean
    className?: string
    isApp?: boolean
    articleId?: string
    isMobileWeb?: boolean
    componentaId:string
    shouldEnableFullScreenGallery?: boolean
}



function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "block", height: "40px", width: "40px", content: "<", background: "#b3b3b3" }}
            onClick={onClick}
        />
    );
}

function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "block", height: "40px", width: "40px", content: ">", background: "#b3b3b3" }}
            onClick={onClick}
        />
    );
}






export class ArticleImageSlider extends React.Component<ArticleImageSliderProps, { currentSlide: number, showFullScreenGallery: boolean }> {
    constructor(props) {
        super(props);
        this.state = {
            currentSlide: 0,
            showFullScreenGallery: false
        }
    }
    public static siteScriptName = "ArticleImageSlider"
    handleOpenGallery = () => {
        if (this.props.isApp) return;
        else {
            this.setState({ showFullScreenGallery: true })
            document.body.style.overflow = "hidden";
        }
    }

    handleCloseGallery = (index) => {
        this.setState({ showFullScreenGallery: false, currentSlide: index })
        document.body.style.overflow = "auto";
    }
    public render() {
        const { imageList, infinite, width, height, imageSliderWidth, isRtl, shouldDisplayCurrentImageIndex, className, isApp, componentaId, shouldEnableFullScreenGallery } = this.props;

const shouldSeparateCreditAndCaption = typeof document !== "undefined" && !!document.querySelector(".galhad.version2");
        let settings = {
            infinite: infinite ? infinite : true,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
            arrows: true,
            rtl: false,
            prevArrow: <PrevArrow />,
            nextArrow: <NextArrow />,
            afterChange: (index) => {
                this.setState({ currentSlide: index });
            }


        }

        const imagesJson = JSON.stringify(imageList)
        return (
            <div className={`article-image-slider ${className ? className : ""}`} style={{ width: imageSliderWidth ? imageSliderWidth : '700px' }}>
              {isApp && < script type="text/javascript" dangerouslySetInnerHTML={{ __html: `const galleryImagesArrayObjects_${componentaId} = ${imagesJson}` }} />}
                {isApp ? <a data-href="image_gallery" className="fullscreen-gallery-icon-pf" href={`image_gallery?componentaId=${componentaId}&index=${this.state.currentSlide}&imageId=${imageList[this.state.currentSlide].imageId}&type=.jpg`}/>: <div onClick={this.handleOpenGallery} className="fullscreen-gallery-icon-pf"></div>}
                <ArticleImagesFullScreenGallery
                    isLtr={!isRtl}
                    images={imageList}
                    index={this.state.currentSlide}
                    articleId={this.props.articleId}
                    show={this.state.showFullScreenGallery}
                    open={this.handleOpenGallery}
                    siteLayoutType={this.props.isApp ? 'mobileApp' : this.props.isMobileWeb ? 'mobileWeb' : 'desktop'}
                    close={this.handleCloseGallery}
                />
                <Slider {...settings}   >
                    {imageList.map((image, i) =>
                        <div key={i}>

                            {isApp ? <a data-href="image_gallery" href={`image_gallery?componentaId=${componentaId}&index=${i}&imageId=${image.imageId}&type=.jpg`}>
                                <img src={image.imageSrc} alt={image.caption} />
                            </a> : <img src={image.imageSrc} title={`${image.caption} (${image.credit})`}  onClick={shouldEnableFullScreenGallery ? ()=>this.handleOpenGallery() : undefined} style={{ width: width ? width : '590px', height: height ? height : '320px' }}  />}
                          {!shouldSeparateCreditAndCaption &&  <div className="slider-credit-caption">
                                <div className="slider-image-caption">{image.caption}</div>
                                <div className="slider-image-credit">({image.credit})</div>
                            </div>}
                        </div>
                    )}
                </Slider>
                {shouldSeparateCreditAndCaption && (
                    <div className="slider-credit-caption">
                        <div className="slider-image-caption">{imageList[this.state.currentSlide].caption}</div>
                        <div className="slider-image-credit">({imageList[this.state.currentSlide].credit})</div>
                    </div>
                )}
                {shouldDisplayCurrentImageIndex && (
                    <div className="current-image-index">
                        {`${this.state.currentSlide + 1} / ${imageList.length}`}
                    </div>
                )}
            </div>
        )
    }
}